import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Amenity, AmenityCategory } from '../../types';
import { amenities } from '../../data/mockData';
import { AmenityMarker } from '../Overlays/AmenityMarker';
import { AmenitiesFilters } from '../Filters/AmenitiesFilters';
import { AmenityPopupCard } from '../Panels/AmenityPopupCard';
import { TopNav } from '../shared/TopNav';
import { MainMenuPanel } from '../Panels/MainMenuPanel';
export function AmenitiesMode() {
  const [selectedAmenity, setSelectedAmenity] = useState<Amenity | null>(null);
  const [activeCategories, setActiveCategories] = useState<Set<AmenityCategory>>(new Set(['Recreation', 'Wellness', 'Social']));
  const [focusedPosition, setFocusedPosition] = useState<{
    x: number;
    y: number;
  } | null>(null);
  const [showMenu, setShowMenu] = useState(false);
  const [cameraDirection] = useState<'N' | 'S' | 'E' | 'W' | 'NE' | 'NW' | 'SE' | 'SW'>('N');
  const toggleCategory = (category: AmenityCategory) => {
    const newCategories = new Set(activeCategories);
    if (newCategories.has(category)) {
      newCategories.delete(category);
    } else {
      newCategories.add(category);
    }
    setActiveCategories(newCategories);
  };
  const handleAmenitySelect = (amenity: Amenity) => {
    setSelectedAmenity(amenity);
    // Center/focus on the amenity with animation
    setFocusedPosition(amenity.coordinates);
  };
  const handleClosePopup = () => {
    setSelectedAmenity(null);
    setFocusedPosition(null);
  };
  const filteredAmenities = amenities.filter(amenity => activeCategories.has(amenity.category));
  return <>
      <TopNav onMenuClick={() => setShowMenu(true)} cameraDirection={cameraDirection} data-id="element-661" />

      {/* Main Menu Panel */}
      <MainMenuPanel isOpen={showMenu} onClose={() => setShowMenu(false)} onOpenControls={() => console.log('Open Controls')} onOpenMediaGallery={() => console.log('Open Media Gallery')} onOpenSettings={() => console.log('Open Settings')} data-id="element-662" />

      {/* Left Filters Panel */}
      <AmenitiesFilters amenities={amenities} selectedCategories={activeCategories} onCategoryToggle={toggleCategory} onAmenitySelect={handleAmenitySelect} data-id="element-663" />

      {/* Animated Background Overlay for Focus Effect */}
      <AnimatePresence data-id="element-664">
        {focusedPosition && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="absolute inset-0 pointer-events-none z-10" style={{
        background: `radial-gradient(circle at ${focusedPosition.x}% ${focusedPosition.y}%, transparent 15%, rgba(0,0,0,0.4) 40%)`
      }} data-id="element-665" />}
      </AnimatePresence>

      {/* Markers - Positioned to the right of filter menu */}
      <div className="absolute inset-0 pointer-events-none" style={{
      left: '320px'
    }} data-id="element-666">
        <div className="relative w-full h-full pointer-events-auto" data-id="element-667">
          {filteredAmenities.map((amenity, index) => <AmenityMarker key={amenity.id} amenity={amenity} isSelected={selectedAmenity?.id === amenity.id} onSelect={() => handleAmenitySelect(amenity)} delay={index * 0.05} data-id="element-668" />)}
        </div>
      </div>

      {/* Popup Card */}
      <AnimatePresence data-id="element-669">
        {selectedAmenity && <AmenityPopupCard amenity={selectedAmenity} onClose={handleClosePopup} position={selectedAmenity.coordinates} data-id="element-670" />}
      </AnimatePresence>
    </>;
}